<script>
	import arrow_left from '$lib/assets/left_arrow.webp';
	import arrow_right from '$lib/assets/right_arrow.webp';

	import '@splidejs/svelte-splide/css/core';
	import { Splide, SplideTrack } from '@splidejs/svelte-splide';

	const options = {
		gap: '3rem',
		autoplay: false,
		pagination: false,
		arrows: true,
		height: 'auto',
		width: '100vw',
		padding: { left: '4rem', right: '4rem', bottom: '1rem' },
		autowidth: true,
		lazyLoad: true,
		perPage: 'auto',
		perMove: 1,
		focus: 0,
		omitEnd: true,

		breakpoints: {
			576: {
				gap: '2rem'
			},
			400: {
				padding: { left: '1rem', right: '0rem' },
				gap: '0.5rem'
			}
		}
	};
</script>

<div class="swiper w-full">
	<Splide hasTrack={false} {options} aria-labelledby="swiper-for-cards">
		<div class="splide__arrows">
			<button class="splide__arrow splide__arrow--prev">
				<img src={arrow_left} alt="arrow" />
			</button>
			<button class="splide__arrow splide__arrow--next">
				<img src={arrow_right} alt="arrow" />
			</button>
		</div>
		<div>
			<SplideTrack>
				<slot />
			</SplideTrack>
		</div>
	</Splide>
</div>

<style>
	:global(.swiper .splide::after) {
		content: '';
		position: absolute;
		height: 100%;
		width: 10%;
		right: 0;
		top: 0;
		background: linear-gradient(270deg, #ffffff -17.72%, rgba(255, 255, 255, 0) 79.75%);
	}
	:global(.splide__arrow) {
		background: transparent !important;
		z-index: 10;
		height: 100%;
		z-index: 1 !important;
	}

	@media screen and (max-width: 1024px) {
		:global(.swiper .splide::after) {
			width: 25%;
		}
	}
</style>
